import React from 'react';
import './Footer.css';

const Footer: React.FC = () => {
  return (
    <footer className="footer n-footer">
      <div className="container n-footer-content">
        <div className="n-footer-brand">
          <span className="n-footer-mark">N</span>
          <span>PERSONAL GYM FUSHIMI</span>
        </div>
        <p>パーソナルジムN伏見</p>
        <small>&copy; 2026 PERSONAL GYM N FUSHIMI</small>
      </div>
    </footer>
  );
};

export default Footer;